(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("i18n/th", [], factory);
	else if(typeof exports === 'object')
		exports["i18n/th"] = factory();
	else
		root["i18n/th"] = factory();
})(window, function() {
return 